export const NewOfferMenuEnum = {
    Sport: 0,
    Casino: 1,
    FreeSpins: 2,
    RealMoney: 3
}

Object.freeze(NewOfferMenuEnum);


export default NewOfferMenuEnum;